import { z } from 'zod'

/***************** 지역 단위 *****************/
export const REGION_TYPE = ['SIDO', 'SIGUNGU'] as const

export const RegionTypeSchema = z.enum(REGION_TYPE)
export type RegionType = z.infer<typeof RegionTypeSchema>

// /regions 의 시도·시군구 한 행. 스펙(RegionDto)은 sigunguName 을 optional 로 그리지만 서버는 시도 행에 null 을 낸다.
// 2026-09-18 백엔드 소스(RegionDto.sigunguName: String?)로 확인. 서버가 함께 내는 priority(정렬 순서)는
// 앱이 읽지 않고 지역 트리 노드를 리터럴로 만드는 곳이 있어 받지 않는다.
export const RegionSchema = z.object({
  code: z.string(),
  sidoName: z.string(),
  sigunguName: z.string().nullable(),
  type: RegionTypeSchema,
})
export type Region = z.infer<typeof RegionSchema>
